import MOCKED_SUMMARIES from "./dashboard/summaries";

export const MOCKED_DASHBOARD_STATE = {
  summaries: MOCKED_SUMMARIES
};
